import React, { useRef, useEffect, useCallback, useState} from 'react';
import PSlider from './PSlider.js';
import ParameterLabel from './ParameterLabel.js';
import ParameterInputEditor from './ParameterInputEditor.js';
import {setParameterSliderDown} from "actions/index.js";
import ModulatorControls from 'components/modulators/ModulatorControls.js';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import {EFFECT_PARAMETER, PARAMETER_VALUE} from 'constants/contextual-help.js';
import {updateParameter} from 'operations/actions.js';
import {
    setShowPianoRoll,
    setShowAutomation,
    setEffectParameterValue,
    deleteParameterMidiMapping,
    setArrangementBottomMode,
} from 'actions/index.js';
import Colors from 'components/Colors.js';
import {isNumber} from 'utils/IsNumber.js';
import Tone from 'tone';
import { Badge, Label, Button, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import {PIANO_ROLL} from 'constants/arrangement-modes.js';
import {SEQUENCER_VIEW} from 'constants/view-modes.js';
import {MAP, DELETE, OFF} from 'constants/midi-map-modes.js';
import Documented from "components/help/Documented.js"
import {connect} from 'react-redux';
import {useParameterEditor} from './useParameterEditor.js';

const colors = new Colors();
const ParameterLabelEditor = ({
    step,
    root,
    deleteParameterMidiMapping,
    showAutomation,
    onClickParameterName,
    setShowModulators,
    midiMapRef,
    onMouseDown,
    isMouseDown,
    setShowModulator,
    ... props
}) => { 
    let [max, setMax] = useState(pow(props.max, 1.0/root));
    let [min, setMin] = useState(pow(props.min, 1.0/root));
    const {
        onEdit,
        editing,
        onKeyPress,
        setEditing,
        value,
        onUpdateParameter,
        onTypedInputChanged,
        inputValue} =
          useParameterEditor({
              root: root,
              midiMapRef,
              convertToRoot: props.convertToRoot,
              isMouseDown, onMouseDown}, props);

    useEffect(() => {
        midiMapRef.current = props.midiMapMode;
    }, [props.midiMapMode]);
    
    const onMouseUp = useCallback(() => {
        props.setParameterSliderDown(undefined);
        if (props.parameter) {
            props.parameter.automation.smoothen();
            props.parameter.mixAutomation.smoothen();
            /*
            // refresh redux
            let val = props.parameter.get(true);
            console.log('refereshing ', val);
            props.setEffectParameterValue(props.parameter.id, val);
            */
        }
        isMouseDown.current = false;
    }, [value, props.parameter]);

    const deletePLocks = useCallback(() => {
        // find all selected steps
        props.pLockedSteps.forEach(
            s => props.parameter.deletePLockForStep(s));
    }, [props.pLockedSteps, props.parameter]);

   
    return (
        <div className="slider-and-labels">
          <div className="parameter-label-container">
          <div
          className="parameter-label effect-parameter-label">
          <Documented
            element={props.parameter}
            onClick={() => onClickParameterName()}
            className="pushable parameter-label-name">{props.name}: </Documented>
          {editing && 
           <ParameterInputEditor
             setEditing={setEditing}
             onUpdateParameter={onUpdateParameter}
             value={value}/>}
          {!editing && 
           <ParameterLabel
             convertToRoot={props.convertToRoot}
             unit={props.unit}
             displayFunction={props.displayFunction}
             isParameter={props.isParameter}
             onEdit={onEdit}
             getValue={props.getValue}
             parameter={props.parameter}/>}
         {!editing && props.pLockedSteps &&
           <div
             onClick={deletePLocks}
             style={{backgroundColor: colors.getColorForTrack(props.pLockedSteps[0].track)}}
             className="p-lock-indicator">P-Locked</div>}
          {props.hasAutomations && 
           <img
             onClick={() => showAutomation()}
             src="/automation-icon-disabled.png" className="automation-icon"/>}
        </div>
        </div>
          {props.children}
      <div
        onMouseDown={(e) => e.stopPropagation()}
        className="slider-and-modulators">
        {!props.hideSlider && 
         <PSlider
           onMouseUp={onMouseUp}
           convertToRoot={props.convertToRoot}
           onUpdateParameter={onUpdateParameter}
           parameter={props.parameter}
           step={step}
           max={max}
           min={min}
           root={root}/>
        }
        <ModulatorControls sequencerEngine={props.sequencerEngine} parameter={props.parameter}/>
      </div>
        </div>);
};

const mapStateToProps = (state, props) => {
    if (!props.parameter) {
        return {};
    }
    return {
        hasAutomations: props.parameter.automations && props.parameter.automations.length > 0
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
        deleteParameterMidiMapping: parameterId => dispatch(deleteParameterMidiMapping(parameterId)),
        setParameterSliderDown: parameter => dispatch(setParameterSliderDown(parameter)),
        setEffectParameterValue: (id, value) => dispatch(setEffectParameterValue(id, value)),
        setShowAutomation: p => dispatch(setShowAutomation(p)),
        setBottomMode: (bottomMode) =>
            dispatch(setArrangementBottomMode(bottomMode)),
        setShowPianoRoll: p => dispatch(setShowPianoRoll(p)),
  };
};


const pow = (a,b) =>
      a < 0 ? -1 * Math.pow(Math.abs(a), b) :
      Math.pow(a,b);

function round(value) {
    return Math.round(value * 1000) / 1000;
}

export default connect(mapStateToProps, mapDispatchToProps)(ParameterLabelEditor);
